import React, { useContext } from "react";
import style from "./index.module.scss";
import className from "classnames";
import { TopicsItem } from "../../../../../service";
import { QuestionnaireContext } from "../../../../../store";
import { isTrue } from "../../../../../../../../Utils/filter";

interface QuestionnaireBarProps {
    checked: number;
    data: TopicsItem[];
    onChange: (val: number) => void;
}

export default function QuestionnaireBar({
    checked,
    data,
    onChange
}: QuestionnaireBarProps) {
    const { questionnaire } = useContext(QuestionnaireContext);

    function isAnswerState(id: string, questions?: TopicsItem[]) {
        let isAnswerBoolean = false;

        for (let item of questionnaire) {
            if (item.id == id) {
                if (item.isAnswer) {
                    isAnswerBoolean = true;
                    break;
                }
                isAnswerBoolean = false;
            } else {
                //id在context里找不到表示是自定义或者阅读理解类型题，questions为子题数组
                if (questions) {
                    for (let subItem of questions) {
                        if (item.id == subItem.id) {
                            if (!item.isAnswer) {
                                isAnswerBoolean = false;
                                return;
                            }
                            isAnswerBoolean = true;
                        }
                    }
                }
            }
        }
        // console.log(id,isAnswerBoolean)
        return isAnswerBoolean;
    }

    return (
        <div className={style.root}>
            <div className={style.top}>
                <div>全部试题</div>
                <div className={style.tip}>
                    <div className={style.already}>已答</div>
                    <div className={style.noAlready}>未答</div>
                </div>
            </div>
            <ul className={style.qidList}>
                {data &&
                    data.map((item, index) => (
                        <li
                            onClick={() => onChange(item.index)}
                            key={index}
                            className={className(style.qidItem, {
                                [style.answered]: isAnswerState(
                                    item.id,
                                    item.questions
                                ),
                                [style.current]: item.index === checked
                            })}>
                            {isTrue(item.requiredFlag) && (
                                <span className="required_overflow" />
                            )}
                            {item.index}
                        </li>
                    ))}
            </ul>
        </div>
    );
}
